// Build product page carousels
window.onload = function () {  
  init();
}
function init() {  
  if(window.Flickity){
    var mediaQuery = window.matchMedia('(max-width: 768px)');
    if(mediaQuery.matches){
        var key_features_carousel = document.querySelector('#key_features_carousel');
        if(document.querySelector('#key_features_carousel')){
          var key_features_carousel_flkty = new Flickity( key_features_carousel, {
            // options
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
            pageDots: true,
            draggable:true
          });
        };

        if(document.querySelectorAll('.d-custom-carousel')){
        var custom_carousels = document.querySelectorAll('.d-custom-carousel').forEach(elem=>{
            var flkty = new Flickity( elem, {
                prevNextButtons: true,
                pageDots: true,
                draggable:true
              });
        });
        }

    }else{
      var custom_carousels = document.querySelectorAll('.d-custom-carousel.enable-flickity-desktop').forEach(elem=>{
        var flkty = new Flickity( elem, {
            prevNextButtons: false,
            pageDots: true,
            draggable:true,
            cellAlign:'left',
            groupCells:true
          });
      })
    };


    // Create carousel for custom testimonial section;
    if (document.querySelector('.custom-testimonials-slider')) {
      var testimonials = document.querySelector('.custom-testimonials-slider');
        var flkty = new Flickity( testimonials, {
            prevNextButtons: false,
            pageDots: false,
            draggable:true,
            cellAlign: 'center',
            autoPlay:3000,
            wrapAround: true
          });
    }
    // if (document.querySelector('.logo-list_with_quote .logo-bar_logos')) {
    //   var logo_list_nav = document.querySelector('.logo-list_with_quote .logo-bar_logos');
    //     var flkty = new Flickity( logo_list_nav, {
    //         prevNextButtons: false,
    //         asNavFor: '.logo-list_with_quote .logo-bar_quotes',
    //         cellAlign: 'left',
    //         pageDots: false,
    //         contain: true
    //       });
    // }

  }else{
    setTimeout(() => {
      init();
    }, 500);
  }

}